"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = exports.QueryClientProvider = void 0;
const react_query_1 = require("react-query");
var react_query_2 = require("react-query");
Object.defineProperty(exports, "QueryClientProvider", { enumerable: true, get: function () { return react_query_2.QueryClientProvider; } });
exports.queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
        },
    },
});
